const getters = {
    teamnominationCart: state => state.teamnominationCart,
    grades: state => state.grades,
    seasons: state => state.seasons,
    divisions: state => state.divisions,
    divisiongroups: state => state.divisiongroups,
    preferreddivisions: state => state.preferreddivisions,
    teamnominationStatus: state => state.teamnominationStatus,
    teamnominationErrors: state => state.teamnominationErrors,
    paymentStatus: state => state.paymentStatus,
    paymentErrors: state => state.paymentErrors,
}

export default getters
